export enum CALENDAR_SERIES_SCOPE {
  THIS = 'THIS',
  THIS_AND_NEXT = 'THIS_AND_NEXT',
  ALL = 'ALL',
}

export type CalendarSeriesScope =
  (typeof CALENDAR_SERIES_SCOPE)[keyof typeof CALENDAR_SERIES_SCOPE];
